// Plain-TS manifest of blog post metadata. Imported both at runtime (by the
// blog routes via index.ts) and at build time (by the prerender plugin in
// vite.config.ts). Keep this file free of React imports so it can be loaded
// from the Vite config's Node context.

import type { PostMeta } from './types';

export const POST_METAS: PostMeta[] = [
  {
    slug: 'beat-battle-theme-ideas',
    title: '50+ Beat Battle Theme Ideas: Prompts That Actually Produce Submissions',
    description:
      'Tested beat battle themes: sample-flip prompts, constraint themes, genre fusions, mood prompts, and gimmick rounds. The ideas Discord hosts and producer meetups actually use - plus an 8-week season template.',
    primaryKeyword: 'beat battle ideas',
    date: '2026-05-22',
    author: 'Prod Battle',
    readMin: 9,
    category: 'guide',
  },
  {
    slug: 'producer-battle-vs-beat-battle-net',
    title: 'Producer Battle vs Beat-Battle.net: Which Is Right for You? (2026)',
    description:
      'Producer Battle vs beat-battle.net in 2026. Why Producer Battle is the deeper platform for serious producers - more modes, weekly bracket tournaments, per-genre ranking, async Daily Challenge, Sample Flip, anti-griefing honor system, and producer-grade profiles.',
    primaryKeyword: 'producer battle vs beat battle net',
    date: '2026-05-05',
    author: 'Prod Battle',
    readMin: 12,
    category: 'guide',
  },
  {
    slug: 'history-of-online-beat-battles',
    title: 'The History of Online Beat Battles: From J Dilla to Platform Era',
    description:
      'How beat battles evolved from the 1990s producer cypher tradition through IllMuzik and STBB forums, then Twitch streaming, to the modern platform era. Verified names, real years, no filler.',
    primaryKeyword: 'history of online beat battles',
    date: '2026-05-05',
    author: 'Prod Battle',
    readMin: 10,
    category: 'pillar',
  },
  {
    slug: 'what-is-a-beat-battle',
    title: 'What Is a Beat Battle? History, Formats, and How to Enter in 2026',
    description:
      'A beat battle is a timed production competition where everyone gets the same sample kit and the audience votes blind. Here is the full history, every format, and how to enter your first one.',
    primaryKeyword: 'what is a beat battle',
    date: '2026-05-04',
    author: 'Prod Battle',
    readMin: 10,
    category: 'pillar',
  },
  {
    slug: 'best-online-beat-battle-sites',
    title: 'Best Online Beat Battle Sites in 2026 (Honest Breakdown)',
    description:
      'The online beat battle platforms actually worth your time in 2026 - what format each uses, who each one is for, and how to pick the right one for how you make beats.',
    primaryKeyword: 'best online beat battle sites',
    date: '2026-05-04',
    author: 'Prod Battle',
    readMin: 9,
    category: 'listicle',
  },
  {
    slug: 'how-to-host-a-beat-battle',
    title: 'How to Host a Beat Battle: Rules, Kits, Voting, and Avoiding the Common Disasters',
    description:
      'Everything you need to run your own beat battle - writing clear rules, building a sample kit, running blind voting, and handling the problems that kill most community-run events.',
    primaryKeyword: 'how to host a beat battle',
    date: '2026-05-04',
    author: 'Prod Battle',
    readMin: 11,
    category: 'guide',
  },
  {
    slug: 'beat-battle-vs-rap-battle',
    title: "Beat Battle vs Rap Battle: What's the Difference?",
    description:
      'Beat battles are producer competitions; rap battles are MC competitions. Same word "battle", completely different sport. Here is how each one works.',
    primaryKeyword: 'beat battle vs rap battle',
    date: '2026-04-29',
    author: 'Prod Battle',
    readMin: 6,
    category: 'guide',
  },
  {
    slug: 'how-to-win-a-beat-battle',
    title: 'How to Win a Beat Battle: 9 Tactics from Past Champions',
    description:
      'Nine tactics that consistently win online beat battles - from kit usage to mix loudness to voting psychology. Lessons from producers on the Prod Battle leaderboard.',
    primaryKeyword: 'how to win a beat battle',
    date: '2026-04-29',
    author: 'Prod Battle',
    readMin: 8,
    category: 'guide',
  },
  {
    slug: 'best-free-daws-for-beatmakers-2026',
    title: 'The 14 Best Free DAWs for Beatmakers in 2026',
    description:
      "Every free DAW worth a producer's time in 2026, ranked by how fast you can ship a battle-ready beat. No demos that nag you, no 30-day trials.",
    primaryKeyword: 'best free DAW for beatmakers',
    date: '2026-04-29',
    author: 'Prod Battle',
    readMin: 12,
    category: 'listicle',
  },
  {
    slug: 'online-beat-battles-complete-guide',
    title: 'Online Beat Battles in 2026: The Complete Guide',
    description:
      'How online beat battles work in 2026: formats, judging, prizes, ranked play, and the platforms that host them. Everything you need to enter your first battle.',
    primaryKeyword: 'online beat battle',
    date: '2026-04-29',
    author: 'Prod Battle',
    readMin: 9,
    category: 'pillar',
  },
  {
    slug: 'how-producer-battles-work',
    title: 'How Producer Battles Work: Rules, Rounds, and Judging',
    description:
      'Inside the rules of a modern producer battle: phases, time limits, sample-kit constraints, blind voting, and how rankings update after each match.',
    primaryKeyword: 'beat battle rules and judging',
    date: '2026-04-29',
    author: 'Prod Battle',
    readMin: 7,
    category: 'guide',
  },
  {
    slug: 'how-to-make-a-trap-beat-in-30-minutes',
    title: 'How to Make a Trap Beat in 30 Minutes (Free DAW)',
    description:
      'Step-by-step trap beat in 30 minutes using a free DAW. 808, hi-hats, melody, arrangement, mix - everything you need to ship a battle-ready trap beat.',
    primaryKeyword: 'how to make a trap beat',
    date: '2026-04-29',
    author: 'Prod Battle',
    readMin: 9,
    category: 'tutorial',
  },
  {
    slug: 'how-to-mix-an-808',
    title: 'How to Mix an 808: 7 Tricks That Make It Hit Harder',
    description:
      'Seven mix tricks that make trap 808s hit on phone speakers, club systems, and Spotify alike. EQ, sidechain, saturation, glide - the working version.',
    primaryKeyword: 'how to mix 808',
    date: '2026-04-29',
    author: 'Prod Battle',
    readMin: 6,
    category: 'tutorial',
  },
  {
    slug: 'how-to-start-beatmaking',
    title: 'How to Start Beatmaking: A Complete Beginner Roadmap',
    description:
      'A complete roadmap for going from zero to your first finished beat. What gear you need, what DAW to pick, what to learn first, and how to ship beats fast.',
    primaryKeyword: 'how to start beatmaking',
    date: '2026-04-29',
    author: 'Prod Battle',
    readMin: 9,
    category: 'pillar',
  },
];

export const POST_META_BY_SLUG: Record<string, PostMeta> = Object.fromEntries(
  POST_METAS.map((m) => [m.slug, m]),
);

// Safer lookup helper. Throws at module load if a post file references a
// slug that is not declared in POST_METAS, which is a build-time mistake.
export function postMeta(slug: string): PostMeta {
  const m = POST_META_BY_SLUG[slug];
  if (!m) throw new Error(`blog post manifest is missing entry for slug: ${slug}`);
  return m;
}
